import{translations as r}from"./constant.js";import{getLocale as o}from"@raisin/cp-utils";const t=t=>{try{const n=o(t),e=r[n.key];if(!e)throw new Error(`no locale found for ${t}`);return e}catch(o){return"test"!==process.env.NODE_ENV&&console.warn(o),r.en}};export{t as default};
//# sourceMappingURL=getMessages.js.map
